import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { AuthenticationResult } from "@azure/msal-browser";
import { ConfigurationService } from "@ramudden/services";
import { Observable, catchError, switchMap } from "rxjs";
import { AuthenticationService } from "../services/authentication.service";

export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const authService = inject(AuthenticationService);
    const configurationService = inject(ConfigurationService);

    if (!request.url.includes(configurationService.configuration.url)) {
        return next(request);
    }

    if (authService.e2eTestToken) {
        const requestClone = request.clone({
            setHeaders: { Authorization: `Bearer ${authService.e2eTestToken}` },
        });
        return next(requestClone);
    }

    return authService.acquireTokenSilent$().pipe(
        catchError(() => {
            return next(request) as Observable<any>;
        }),
        switchMap((result: AuthenticationResult) => {
            const requestClone = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${result.accessToken}`,
                },
            });
            return next(requestClone);
        }),
    );
};
